export function globalFormatDate(value) {
  if (value === 0)
    return "--";

  const now = new Date();
  const date = new Date(value * 1000);

  // if the post happened TODAY, display "Today, time"
  if (now.getYear() == date.getYear() && now.getMonth() == date.getMonth() && now.getDate() == date.getDate())
    return 'Сегодня, ' + date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit'
    });

  // if the post happened YESTERDAY, display "Yesterday, time"
  const dateYesterday = new Date((new Date()).valueOf() - 86400000); // 1000 * 60 * 60 * 24 milliseconds
  if (dateYesterday.getYear() == date.getYear() && dateYesterday.getMonth() == date.getMonth() && dateYesterday.getDate() == date.getDate())
    return 'Вчера, ' + date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit'
    });

  // if the post happened prior to yesterday, display full date and time
  const options = {
    month: 'long',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  };
  return date.toLocaleString('en-GB', options);
}
